module.exports = __webpack_public_path__ + "img/elche-logo-icon.203dac22.png";